import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { useEffect, useMemo } from 'react'
import { fetchOrderCancellationConfigs } from 'actions/OrderActions'

function useOrderCancellationConfigs(id?: string, orderId?: string): [
  cancellationConfig: App.OrderItemHotelCancellationConfig,
  cancellationConfigLoading: boolean,
  cancellationConfigError: any
] {
  const dispatch = useAppDispatch()

  const cancellationConfigs = useAppSelector(state =>
    orderId ? state.orders.cancellationConfigs[orderId] : undefined,
  )
  const fetching = useAppSelector(state =>
    orderId ? state.orders.cancellationConfigsFetching[orderId] : false,
  )
  const error = useAppSelector(state =>
    orderId ? state.orders.cancellationConfigsErrors[orderId] : undefined,
  )

  useEffect(() => {
    if (orderId) {
      dispatch(fetchOrderCancellationConfigs(orderId))
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId])

  const config = cancellationConfigs?.[id ?? '']

  const orderItemCancellationConfig: App.OrderItemHotelCancellationConfig = useMemo(() => ({
    policyType: config?.policy_type || 'non-refundable',
    policyDeadline: config?.policy_deadline || '',
    canUseBookingProtection: config?.can_use_booking_protection || false,
    canUseCancellationProtection: config?.can_use_cancellation_protection || false,
    canAutoRefund: config?.can_auto_refund || false,
    canRequestRefund: config?.can_request_refund || false,
    canRefundToOrigin: config?.can_refund_to_origin || false,
    canRefundToCredit: config?.can_refund_to_credit || false,
    canRefund: config?.can_refund || false,
    blockAutoRefundReasons: config?.block_auto_refund_reasons || [],
  }), [config])

  return [orderItemCancellationConfig, fetching, error]
}

export default useOrderCancellationConfigs
